import { render, staticRenderFns } from "./handleAgreement.vue?vue&type=template&id=8bfe17b2&scoped=true"
import script from "./handleAgreement.vue?vue&type=script&lang=js"
export * from "./handleAgreement.vue?vue&type=script&lang=js"
import style0 from "./handleAgreement.vue?vue&type=style&index=0&id=8bfe17b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfe17b2",
  null
  
)

export default component.exports